import axios from 'axios';
import * as XLSX from 'xlsx';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Tag } from 'primereact/tag';
import { Skeleton } from 'primereact/skeleton';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { formatedDate } from '../../Helper/constent';
import { Dialog } from 'primereact/dialog';
import OrderPrint from '../PrintHelper/OrderPrint';
import { InputNumber } from 'primereact/inputnumber';

const OrderReport = () => {
    const { apiUrl, apiHeadersJson, store_id, auth_routes } = useContext(ConfigContext);
    const [rows, setRows] = useState([]);
    const [Status, setStatus] = useState(null);
    const [orderLoading, setOrderLoading] = useState(false);
    const [prStatus, setPrStatus] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [keyword, setKeyword] = useState(null);
    const [callApi, setCallApi] = useState(true);
    const toast = useRef(null);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [onlineAmount, setOnlineAmount] = useState(null);
    const [cashAmount, setCashAmount] = useState(null);
    const [remaining, setRemaining] = useState(0);
    const [cardAmount, setCardAmount] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState(1);
    const { limit, order } = useParams();
    const [rowsPerPage, setRowsPerPage] = useState(limit || 10);
    const [sortOrder, setSortOrder] = useState(order, 'DESC');
    const navigate = useNavigate();
    const headers = apiHeadersJson;
    const [orderInfo, setOrderInfo] = useState({});

    //print states
    const [dataLoading, setDataLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [printProducts, setPrintProducts] = useState([]);
    const [user, setUser] = useState({});
    const [isReadyToPrint, setIsReadyToPrint] = useState(false);

    if (!limit || !order || !['ASC', 'DESC'].includes(order.toUpperCase())) {
        navigate('/OrderReport/30/DESC')
    }


    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/GetOrderReport`, { params: { store_id, limit, order, keyword, action_status: Status === "All" ? '' : Status, purchase_status: prStatus === "All" ? '' : prStatus, start_date: startDate, end_date: endDate }, headers });
            const { success, data, message } = response.data;
            setCallApi(false);
            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };


    const handleCancel = () => {
        setShowConfirmationDialog(false);
        setOrderInfo({})
    };

    const handleConfirm = (info) => {
        setOrderInfo(info)
        setShowConfirmationDialog(true);
    };

    const handleSubmit = async () => {
        const total_adv = Number(cashAmount) + Number(onlineAmount) + Number(cardAmount);
        if (remaining < total_adv || total_adv < 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please check the amount', life: 1000 });
            return;
        }
        const body = {
            order_id: orderInfo?.order_id,
            payment_method: paymentMethod,
            cash_amount: (paymentMethod === 1 || paymentMethod === 3) ? cashAmount : 0,
            online_amount: (paymentMethod === 2 || paymentMethod === 3) ? onlineAmount : 0,
            card_amount: (paymentMethod === 4) ? cardAmount : 0,
        };

        try {
            setOrderLoading(true);
            const response = await axios.post(`${apiUrl}/Management/PaidOrder`, body, { headers });
            setOrderLoading(false);
            const { success, message } = response.data;
            if (success) {
                setShowConfirmationDialog(false);
                GetList();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 1000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 1000 });
            }
        } catch (error) {
            console.log('error', error);
            setOrderLoading(false);
        }
    };

    const handleMethodChange = (event) => {
        const selectedValue = parseInt(event.target.value, 10);
        setPaymentMethod(selectedValue);
    };

    const handlePrint = async (id) => {
        try {
            await getPrintInfo(id);
            setIsReadyToPrint(true);
        } catch (error) {
            console.log('error', error);
            alert('error while printing');
        }
    };

    useEffect(() => {
        if (isReadyToPrint && invoiceData && printProducts.length > 0 && user) {
            performPrint();
            setIsReadyToPrint(false);
        }
    }, [invoiceData, printProducts, user]);

    const performPrint = () => {
        const invoiceContainer = document.querySelector('.puechase-invoice-container');
        if (!invoiceContainer) {
            alert("Order Invoice not found.");
            return;
        }

        const styles = Array.from(document.styleSheets)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules)
                        .map(rule => rule.cssText)
                        .join('\n');
                } catch (e) {
                    return '';
                }
            })
            .join('\n');

        const htmlContent = `
                    <html>
                        <head><style>${styles}</style></head>
                        <body>${invoiceContainer.innerHTML}</body>
                    </html>
                `;

        if (window.electronAPI) {
            window.electronAPI.silentPrint(htmlContent);
        } else {
            const printWindow = window.open('', '_blank');
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 1000);
        }
    };

    const getPrintInfo = async (id) => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/OrderInvoice`, { params: { order_id: id, }, headers });
            const { success, data, prodcuts, user, message } = response.data;

            if (success) {
                setInvoiceData(data[0]);
                setPrintProducts(prodcuts);
                setUser(user[0]);
                if (prodcuts?.length === 0) {
                    alert('Sorry No Product Found Please Check The Bill');
                }
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('Error fetching invoice:', error);
            alert('error while fetching print data');
        } finally {
            setDataLoading(false);
        }
    };


    useEffect(() => {
        store_id && GetList();
    }, [store_id, limit, order]);

    useEffect(() => {
        callApi && GetList();
    }, [callApi]);

    useEffect(() => {
        const timer = setTimeout(() => { keyword && GetList(); }, 1500);
        return () => clearTimeout(timer);
    }, [keyword]);

    const clearFilters = () => {
        setKeyword("");
        setStartDate(null);
        setEndDate(null);
        setStatus("");
        setPrStatus("");
        setCallApi(true)
    };
    const applyFilters = () => {
        GetList();
        setCallApi(true)
    };

    const paginatorLeft = <Button type="button" icon="pi pi-refresh" text onClick={GetList} />;

    const ActionBody = (data) => {
        const GetActionStatusById = (info) => {
            let value = info.action_type == 1 ? 'Edited' : info.action_type == 2 ? 'Deleted' : '';
            let severity = info.action_type == 1 ? 'info' : info.action_type == 2 ? 'danger' : '';
            return { value, severity };
        };

        const CheckShowBtns = (info) => {
            const edit = info.order_status == 1 && info.action_type != 2;
            const verify = info.order_status == 1 && info.action_type != 2;
            const deleteBtn = info.order_status == 1 && info.action_type != 2;
            const print_btn = info.action_type != 2;
            return { edit, deleteBtn, print_btn, verify };
        };

        return (
            <>
                {data.action_type != 0 && (
                    <Tag severity={GetActionStatusById(data).severity} value={GetActionStatusById(data).value}></Tag>
                )}
                <div className="ms-2 btn-group" role="group" aria-label="Action Buttons">
                    {/* Edit Button */}
                    {CheckShowBtns(data).edit && (
                        <NavLink to={`/OrdersEntry/${data.order_id}/${data.store_id}`} className="btn btn-primary">
                            <i className="pi pi-pen-to-square"></i>
                        </NavLink>
                    )}
                    {/* Print Button */}
                    {CheckShowBtns(data).print_btn && auth_routes.includes('PrintOrder') &&
                        <button disabled={dataLoading} onClick={() => handlePrint(data.order_id)} type='button' className="btn btn-info text-white">
                            {dataLoading ? (
                                <i className="pi pi-spin pi-spinner"></i>
                            ) : (
                                <i className="pi pi-print"></i>
                            )}
                        </button>}
                    {CheckShowBtns(data).verify && (
                        <button
                            className="btn btn-success"
                            onClick={() => handleConfirm(data)}
                        >
                            <i className="pi pi-check-square"></i>
                        </button>
                    )}
                    {/* Delete Button */}
                    {CheckShowBtns(data).deleteBtn && (
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(data.order_id, data.store_id)}
                        >
                            <i className="pi pi-trash"></i>
                        </button>
                    )}
                </div>
            </>
        );
    };



    const LinkBody = (data) => {
        return (
            data.invoice_number ?
                <NavLink to={`/ViewOrder/${data.order_id}`} className={'text-primary'} style={{ cursor: 'pointer', textDecoration: 'none' }}>{data.invoice_number}</NavLink>
                :
                <NavLink to={`/ViewOrder/${data.order_id}`} className={'text-primary'} style={{ cursor: 'pointer', textDecoration: 'none' }}>{"View Sale"}</NavLink>
        );
    };
    const DateBody = (data) => {
        return (
            <div>{formatedDate(data.order_date)}</div>
        );
    };

    const confirmDelete = (id, store_id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Order?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => DeteteSaleProducts(id, store_id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const DeteteSaleProducts = async (id, store_id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Management/DeleteOrderProducts`, { params: { order_id: id, store_id }, headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const PaymentMethods = [
        { value: 1, label: 'Cash' },
        { value: 2, label: 'Online' },
        { value: 3, label: 'Cash & Online' },
        { value: 4, label: 'Card' },
    ]

    const CheckAmount = () => {
        const adv_amount = Number(orderInfo?.adv_online_amount) + Number(orderInfo?.adv_card_amount) + Number(orderInfo?.adv_cash_amount);
        const total_remaining = orderInfo?.grand_total_amount - adv_amount;
        const half_amount = total_remaining * 0.5;

        setRemaining(total_remaining);

        if (paymentMethod === 1) {
            setCashAmount(total_remaining);
        }
        if (paymentMethod === 2) {
            setOnlineAmount(total_remaining);
        }
        if (paymentMethod === 4) {
            setCardAmount(total_remaining);
        }
        if (paymentMethod === 3) {
            setOnlineAmount(half_amount);
            setCashAmount(half_amount);
        }
    }

    useEffect(() => {
        orderInfo.order_id && CheckAmount();
    }, [orderInfo.order_id, paymentMethod]);

    return (
        <div className="container-fluid">
            <Dialog
                header="Delivered Order"
                visible={showConfirmationDialog}
                style={{ width: '35vw' }}
                onHide={handleCancel}
                footer={
                    <div>
                        <button className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                        </button>
                        <button className="btn btn-primary ml-2" onClick={handleSubmit} disabled={orderLoading}>
                            {orderLoading ? "Please Wait ...!" : "Delivered"}
                        </button>
                    </div>
                }
            >
                <div className="p-fluid">
                    <div className="row">
                        <div className="col-6">
                            <div className="p-field">
                                <label htmlFor="customerName">Customer Name</label>
                                <InputText id="customerName" value={orderInfo?.customer_name} />
                            </div>
                            <div className="p-field mt-2">
                                <label htmlFor="expectedDate">Expected Delivery Date</label>
                                <input
                                    id="expectedDate"
                                    type="date"
                                    className="form-control mt-2"
                                    value={orderInfo?.expected_date}
                                />
                            </div>
                            <div className="p-field mt-2">
                                <label htmlFor="paymentMethod">Payment Method</label>
                                <select
                                    className="form-select mt-1"
                                    value={paymentMethod || ""}
                                    onChange={handleMethodChange}
                                >
                                    <option value="" disabled>
                                        Select a Method
                                    </option>
                                    {PaymentMethods.map((method) => (
                                        <option key={method.value} value={method.value}>
                                            {method.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="col-6">
                            {/* Cash Amount */}
                            {paymentMethod === 1 || paymentMethod === 3 ? (
                                <div className="p-field mt-2">
                                    <label htmlFor="cashAmount">Cash Amount</label>
                                    <InputText id="cashAmount" value={cashAmount} onChange={(e) => setCashAmount(e.target.value)} />
                                </div>
                            ) : null}

                            {/* Online Amount */}
                            {paymentMethod === 2 || paymentMethod === 3 ? (
                                <div className="p-field mt-2">
                                    <label htmlFor="onlineAmount">Online Amount</label>
                                    <InputText id="onlineAmount" value={onlineAmount} onChange={(e) => setOnlineAmount(e.target.value)} />
                                </div>
                            ) : null}

                            {/* Card Amount */}
                            {paymentMethod === 4 ? (
                                <div className="p-field mt-2">
                                    <label htmlFor="cardAmount">Card Amount</label>
                                    <InputText id="cardAmount" value={cardAmount} onChange={(e) => setCardAmount(e.target.value)} />
                                </div>
                            ) : null}

                            {/* Total Amount */}
                            <div className="p-field mt-2">
                                <label htmlFor="totalAmount">Remaining Amount</label>
                                <InputText id="totalAmount" value={remaining} />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            <Toast ref={toast} />
            <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="main-heading">
                    <h6>Order Report</h6>
                </div>
                <div className="main-heading-right">
                    <h6>Reports/Order Report</h6>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 mt-4">
                    <div className="card">
                        <div className="rounded-top px-3 py-2 bg-dark d-flex flex-wrap justify-content-between align-items-center">
                            <h4 className="text-white">Order Report</h4>
                        </div>
                        <div className='card-header'>
                            <div className="row">
                                <div className="col-md-3">
                                    <input
                                        type="date"
                                        className="form-control h-100"
                                        onChange={(e) => setStartDate(e.target.value)}
                                        value={startDate || ''}
                                        placeholder="Start date"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <input
                                        type="date"
                                        className="form-control h-100"
                                        onChange={(e) => setEndDate(e.target.value)}
                                        value={endDate || ''}
                                        placeholder="End date"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <select
                                        className="form-select h-100"
                                        value={Status || ""}
                                        onChange={(e) => setStatus(e.target.value)}>
                                        <option value="" disabled>Select Action Status</option>
                                        <option value={null}>All</option>
                                        <option value="0">Created</option>
                                        <option value="1">Edited</option>
                                        <option value="2">Deleted</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <div className="d-flex justify-content-center align-items-between">
                                        <Button label="Filter"
                                            disabled={!keyword && !store_id && !startDate && !endDate && !Status && !prStatus}
                                            icon="pi pi-filter" className="ms-3" onClick={applyFilters} />
                                        <Button
                                            disabled={!keyword && !store_id && !startDate && !endDate && !Status && !prStatus}
                                            label="Clear" icon="pi pi-times" severity='secondary' className="ms-3" onClick={clearFilters} />
                                    </div>
                                </div>
                                <div className="mt-3 col-md-9"></div>
                                <div className="mt-3 col-md-3">
                                    <IconField iconPosition="left" className='w-100'>
                                        <InputIcon className="pi pi-search"> </InputIcon>
                                        <InputText
                                            onChange={(e) => setKeyword(e.target.value)}
                                            className='w-100'
                                            placeholder="Search..."
                                        />
                                    </IconField>
                                </div>
                            </div>


                        </div>
                        {dataTableLoading ? (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                <Skeleton shape="rectangle" width="100%" height="40px" className="mb-1" />
                            ))
                        ) : (
                            <>
                                <div className="d-flex flex-wrap justify-content-between align-items-center">
                                    <div className="d-flex align-items-center p-3">
                                        <span className="me-2">Show:</span>
                                        <InputNumber
                                            value={rowsPerPage}
                                            onChange={(e) => setRowsPerPage(e.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    navigate(`/OrderReport/${rowsPerPage}/${sortOrder}`)
                                                }
                                            }}
                                            mode="decimal"
                                            showButtons
                                            min={1}
                                            step={10}
                                            className="me-3"
                                        />
                                        <span className="me-2">entries</span>
                                    </div>
                                    <div className="d-flex align-items-center p-3">
                                        <span className="me-2">Sort Order:</span>
                                        <select
                                            className="form-select"
                                            value={sortOrder}
                                            onChange={(e) => { setSortOrder(e.target.value); navigate(`/OrderReport/${rowsPerPage}/${e.target.value}`) }}
                                            style={{ width: '100px' }}
                                        >
                                            <option value="ASC">Ascending</option>
                                            <option value="DESC">Descending</option>
                                        </select>
                                    </div>
                                </div>
                                <DataTable
                                    value={rows}
                                    paginator
                                    rows={rowsPerPage}
                                    paginatorTemplate="CurrentPageReport PaginatorLeft"
                                    currentPageReportTemplate="Total Records: {totalRecords}"
                                    paginatorLeft={paginatorLeft}
                                    paginatorRight={<></>}
                                    sortOrder={sortOrder === 'ASC' ? 1 : -1}
                                >
                                    <Column field="customer_name" header="Customer" sortable />
                                    {/* <Column field="store_name" header="Store" /> */}
                                    <Column field={LinkBody} header="Invoice" />
                                    <Column field={DateBody} header="Date" />
                                    <Column field="user_name" header="By" />
                                    <Column header="Status" body={(data) => (<Tag severity={data.order_status === 2 ? "success" : "warning"} value={data.order_status === 2 ? "Delivered" : "Pending"} />)} />
                                    <Column field="grand_total_amount" header="Total" sortable />
                                    <Column body={ActionBody} header="Action" />
                                </DataTable>

                            </>
                        )}
                    </div>
                    <div className="mb-5"></div>
                </div>
            </div>
            {isReadyToPrint && <OrderPrint orderDetails={invoiceData} products={printProducts} user={user} isShow={false} />}
        </div>
    );
};

export default OrderReport;
